import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { UserAuth } from "../context/AuthContext";

const Signup = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [error, setError] = useState("");
  const { user, signUp } = UserAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const disabled =
      email === "" || password === "" || displayName === "" || !isChecked;
    setDisabled(disabled);
  }, [email, password, displayName, isChecked]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await signUp(email, password, displayName, isChecked);
      navigate("/");
    } catch (error) {
      console.log(error);
      setError("正しいEmailとパスワードを入力してください");
    }
  };

  return (
    <>
      <div className="w-full h-screen">
        <img
          className="hidden sm:block absolute w-full h-full object-cover"
          src="https://source.unsplash.com/23LET4Hxj_U"
          alt="/"
        />
        <div className="bg-black/60 fixed top-0 left-0 w-full h-screen"></div>
        <div className="fixed w-full px-4 py-24 z-50">
          <div className="max-w-[450px] h-[600px] mx-auto bg-black/75 text-white">
            <div className="max-w-[320px] mx-auto py-16">
              <h1 className="text-3xl font-bold">会員登録</h1>
              {error ? <p className="p-3 bg-blue-400 my-2">{error}</p> : null}
              <form
                onSubmit={handleSubmit}
                className="w-full flex flex-col py-4"
              >
                <input
                  onChange={(e) => setEmail(e.target.value)}
                  className="p-3 my-2 bg-gray-700 rouded"
                  type="email"
                  placeholder="Email"
                  autoComplete="email"
                />
                <input
                  onChange={(e) => setPassword(e.target.value)}
                  className="p-3 my-2 bg-gray-700 rouded"
                  type="password"
                  placeholder="パスワード"
                  autoComplete="current-password"
                />
                <input
                  onChange={(e) => setDisplayName(e.target.value)}
                  className="p-3 my-2 bg-gray-700 rouded"
                  type="text"
                  placeholder="お名前"
                />
                <div className="flex justify-between items-center text-sm text-gray-600">
                  <>
                    <p>
                      <input
                        onChange={(e) => setIsChecked(e.target.value)}
                        className="mr-2"
                        type="checkbox"
                      />
                    </p>
                    <Link to="/terms">利用規約に同意する</Link>
                  </>
                </div>
                <button
                  disabled={disabled}
                  className="bg-blue-600 py-3 my-6 rounded font-bold"
                >
                  会員登録
                </button>
                <p className="py-8">
                  <span className="text-gray-600">
                    THE BeatsBaseアカウントをお持ちですか?
                  </span>{" "}
                  <Link to="/login">ログイン</Link>
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Signup;
